export default __webpack_public_path__ + "static/media/signin-persona-teleoperator.9939b02b.svg";